import React, { ComponentProps, FC, ReactNode } from 'react';
import { Button } from '@wix/design-system';

import s from './AnimatedIconButton.scss';
import classNames from 'classnames';

type Props = {
  animatedIcon?: ReactNode;
} & ComponentProps<typeof Button>;

export const AnimatedIconButton: FC<Props> = ({
  animatedIcon,
  className,
  children,
  ...restProps
}) => {
  return (
    <Button
      {...restProps}
      className={classNames(
        className,
        s.root,
        s.withCustomPadding,
        s.withCustomBackgroundColor,
      )}
    >
      <span className={s.content}>
        {children}
        <span className={s.animatedIcon}>{animatedIcon}</span>
      </span>
    </Button>
  );
};
